import { BaseContext } from '../../../utils/basecontext';
import { APIModel, APIModelImpl, APIModelHandler } from '../../toolkit/uicomponentapimodel';
import { CategoryDtoImpl, CategoryDto } from '../../../core/dto/categories/categorydto';
import { GetProfileDtoImpl } from '../../../core/dto/getprofile/getprofiledto';
import { GetProfileDetailsResponse } from '../../../core/api/myaccount/getprofiledetails/getprofiledetailsresponse';
import { GetProfileDetailsRequestImpl } from '../../../core/api/myaccount/getprofiledetails/getprofiledetailsrequest';
import { EditProfileDtoImpl } from '../../../core/dto/editprofile/editprofiledto';
import { UpdateProfileFeatures } from '../../../core/updateprofilefeatures';
import { EditProfileResponse } from '../../../core/api/myaccount/editprofile/editprofileresponse';
import { EditProfileRequestImpl } from '../../../core/api/myaccount/editprofile/editprofilerequest';
import { MyAccountDto } from '../../../core/dto/myaccount/myaccountdto';
import { APIFeatures } from '../../../core/util/apifeatures';
import { PackStatusDtoImpl } from '../../../core/dto/packstatus/packstatusdto';
import { PackStatusResponse } from '../../../core/api/packstatus/packstatusresponse';
import { PackStatusRequestImpl } from '../../../core/api/packstatus/packstatusrequest';
import { MyAccountProcessorFactory } from '../../../core/processorfactory/myaccountprocessorfactory';
import { CategoriesResponse } from '../../../core/api/categories/categoriesresponse';
import { CategoriesRequestImpl } from '../../../core/api/categories/categoriesrequest';
import { DeleteToneDtoImpl } from '../../../core/dto/deletetone/deletetonedto';
import { DeleteToneResponse } from '../../../core/api/tune/deletetone/deletetoneresponse';
import { DeleteToneRequestImpl } from '../../../core/api/tune/deletetone/deletetonerequest';


export interface MyAccountAPIModel extends APIModel
{
    getCategories(): void;
    getProfileDetailsAPI(): void;
    editProfileAPI(myAccountDto: MyAccountDto): void;
    getPackStatusAPI(): void;
    editProfiePhotoAPI(myAccountDto: MyAccountDto):void;
    unsubscribeUser(): void;
}

export class MyAccountAPIModelImpl extends APIModelImpl implements MyAccountAPIModel
{
    private myAccountProcessor: MyAccountProcessorFactory;
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler) 
    {
        super(applicationContext, apiModelHandler);
        this.myAccountProcessor = this.getAPIProcesssorFactory().getMyAccountProcessorFactory();
    }

    getCategoriesData(): CategoryDto[]
    {
        let list: CategoryDto[] = [];

        let categorydto1 = new CategoryDtoImpl();
        categorydto1.setId("561");
        categorydto1.setTitle("ISLAMIC");
        categorydto1.setImgPath("https://callertunes.etisalat.ae/en/islamic_small1519051932981.jpg");

        let categorydto2 = new CategoryDtoImpl();
        categorydto2.setId("515");
        categorydto2.setTitle("FRENCH");
        categorydto2.setImgPath("https://callertunes.etisalat.ae/en/english_small1519049946025.jpg");

        let categorydto3 = new CategoryDtoImpl();
        categorydto3.setId("433");
        categorydto3.setTitle("BURMESE");
        categorydto3.setImgPath("https://callertunes.etisalat.ae/en/arabic_small1519049116830.jpg");

        let categorydto4 = new CategoryDtoImpl();
        categorydto4.setId("541");
        categorydto4.setTitle("INTERNATIONAL");
        categorydto4.setImgPath("https://callertunes.etisalat.ae/en/international_small1519051024200.jpg");

        let categorydto7 = new CategoryDtoImpl();
        categorydto7.setId("479");
        categorydto7.setTitle("SOUTHASIAN");
        categorydto7.setImgPath("https://callertunes.etisalat.ae/en/southasian_small1519053949221.jpg");


        list.push(categorydto1);
        list.push(categorydto2);
        list.push(categorydto3);
        list.push(categorydto4);
        list.push(categorydto7);
       

        return list;
    }    

    getCategories(): void 
    {
      let categoryDto = new CategoryDtoImpl();
      categoryDto.setLanguage(this.getContext().getUserContext().getLanguage());
      
      this.getAPIProcesssorFactory().getCategoriesAPIProcessorFactory().getCategories()
                 .success((categoriesResponse : CategoriesResponse)=>
                  {
                      this.getAPIModelHandler().onSuccess(APIFeatures.SIGNUP_CATEGORIES, 
                      categoriesResponse.getDescription(), categoriesResponse.getCategoriesList()); 
                  })
                .failure((categoriesResponse : CategoriesResponse)=>
                {
                    this.getAPIModelHandler().onFailure(APIFeatures.SIGNUP_CATEGORIES, 
                    categoriesResponse.getDescription(), categoriesResponse);
                  })
                .execute(new CategoriesRequestImpl(categoryDto));
        // this.getAPIProcesssorFactory().getSignupCategoriesProcessorFactory().getSignupCategoriesDetails()
        // .success((signUpCategoriesResponse : SignupCategoriesResponse)=>
        // {
        //     this.getAPIModelHandler().onSuccess(signUpCategoriesResponse.getAPIFeature(), 
        //     signUpCategoriesResponse.getDescription(), signUpCategoriesResponse.getSignupCategoriesDtos());
        // })
        // .failure((signUpCategoriesResponse : SignupCategoriesResponse)=>
        // {
        //     this.getAPIModelHandler().onFailure(signUpCategoriesResponse.getAPIFeature(), 
        //     signUpCategoriesResponse.getDescription(), {});
        // })
        // .execute(new SignupCategoriesRequestImpl(new CategoryDtoImpl()));
    }

    unsubscribeUser(): void {
      let deleteToneDto = new DeleteToneDtoImpl();
            deleteToneDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
            deleteToneDto.setLanguage(this.getContext().getUserContext().getLanguage());
            deleteToneDto.setToneId("");
            deleteToneDto.setPackName(this.getContext().getUserContext().getPackName());
console.log("---tiger"+deleteToneDto.getPackName());
            this.getAPIProcesssorFactory().getToneProcessorFactory()
            .getDelteTone()
            .success((deleteToneResponse: DeleteToneResponse)=>
            {
                this.getAPIModelHandler().onSuccess(deleteToneResponse.getAPIFeature(), 
                deleteToneResponse.getDescription(), deleteToneResponse);
              
              })
            .failure((deleteToneResponse: DeleteToneResponse)=>
              {
                this.getAPIModelHandler().onFailure(deleteToneResponse.getAPIFeature(), 
                deleteToneResponse.getDescription(), undefined);
              })
            .execute(new DeleteToneRequestImpl(deleteToneDto));    
    }
    
    getProfileDetailsAPI(): void 
    { 
            let getProfileDto = new GetProfileDtoImpl();
            getProfileDto.setIdentifier("GetUserDetails");
            getProfileDto.setLanguage(this.getContext().getUserContext().getLanguage());
            getProfileDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
    
            console.log("----------yellowmodelsuccess");
            this.myAccountProcessor.getGetProfileDetailsAPIProcessor()
            
            .success((getProfileDetailsResponse: GetProfileDetailsResponse)=>
            {
             
                console.log("----------yellowmodelsuccess");
                this.getAPIModelHandler().onSuccess(getProfileDetailsResponse.getAPIFeature(), 
                getProfileDetailsResponse.getDescription(), getProfileDetailsResponse
                .getProfileDetailsDto());
               
             })
            .failure((getProfileDetailsResponse: GetProfileDetailsResponse)=>
             {
              console.log("----------yellowmodelfailure");
               this.getAPIModelHandler().onFailure(getProfileDetailsResponse.getAPIFeature(), 
               getProfileDetailsResponse.getDescription(), undefined);
             })
            .execute(new GetProfileDetailsRequestImpl(getProfileDto));
    }

    editProfileAPI(myAccountDto: MyAccountDto): void 
    { 
            let editProfileDto = new EditProfileDtoImpl();
            editProfileDto.setIdentifier(UpdateProfileFeatures.IdentifierUpdateUsername); //UpdateUserName or updateemail or UpdateCategories
            editProfileDto.setLanguage(this.getContext().getUserContext().getLanguage());
            editProfileDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
            editProfileDto.setServType(UpdateProfileFeatures.ServTypeUpdateUsername);//UPDATE_USER_NAME or UPDATE_CATAGORIES or UPDATE_EMAIL or UPDATE_PROFILE_PIC
            editProfileDto.setUpdatableServiceValue(myAccountDto.getUserName()); // name or email or categoryId
    
            this.myAccountProcessor.getEditProfileAPIProcessor()
            .success((editProfileResponse: EditProfileResponse)=>
            {
                this.editCategories(myAccountDto);
             })
            .failure((editProfileResponse: EditProfileResponse)=>
             {
               this.getAPIModelHandler().onFailure(editProfileResponse.getAPIFeature(), 
               editProfileResponse.getDescription(), undefined);
             })
            .execute(new EditProfileRequestImpl(editProfileDto));
    }
    editProfiePhotoAPI(myAccountDto: MyAccountDto): void 
    { 
            let editProfileDto = new EditProfileDtoImpl();
            editProfileDto.setIdentifier(UpdateProfileFeatures.IdentifierUpdateProfilePic); //UpdateUserName or updateemail or UpdateCategories
            editProfileDto.setLanguage(this.getContext().getUserContext().getLanguage());
            editProfileDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
            editProfileDto.setServType(UpdateProfileFeatures.ServTypeUpdateProfilepic);//UPDATE_USER_NAME or UPDATE_CATAGORIES or UPDATE_EMAIL or UPDATE_PROFILE_PIC
            editProfileDto.setUpdatableServiceValue(myAccountDto.getProfileImage()); // name or email or categoryId
    
            this.myAccountProcessor.getEditProfileAPIProcessor()
            .success((editProfileResponse: EditProfileResponse)=>
            {
              
              this.getAPIModelHandler().onSuccess(editProfileResponse.getAPIFeature(), 
              editProfileResponse.getDescription(), myAccountDto);
             })
            .failure((editProfileResponse: EditProfileResponse)=>
             {
              console.log(editProfileResponse.getAPIFeature);
               this.getAPIModelHandler().onFailure(editProfileResponse.getAPIFeature(), 
               editProfileResponse.getDescription(), undefined);
             })
            .execute(new EditProfileRequestImpl(editProfileDto));
    }
    getPackStatusAPI(): void 
     { 
             console.log("packStatusAPI() invoked");
             let packStatusDto = new PackStatusDtoImpl();
             packStatusDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
    
             this.myAccountProcessor.getPackStatus()
             .success((packStatusResponse: PackStatusResponse)=>
             {
                 console.log("packStatusAPI success invoked"+packStatusResponse.getAPIFeature());
                 this.getAPIModelHandler().onSuccess(packStatusResponse.getAPIFeature(), 
                 packStatusResponse.getDescription(), packStatusResponse.getPackStatusDto().getPackName());
               
              })
             .failure((packStatusResponse: PackStatusResponse)=>
              {
                this.getAPIModelHandler().onFailure(packStatusResponse.getAPIFeature(), 
                packStatusResponse.getDescription(), undefined);
              })
             .execute(new PackStatusRequestImpl(packStatusDto));
     } 

    private editCategories(myAccountDto: MyAccountDto)
    {
        let editProfileDto = new EditProfileDtoImpl();
        editProfileDto.setIdentifier(UpdateProfileFeatures.IdentifierUpdateCategories); //UpdateUserName or updateemail or UpdateCategories
        editProfileDto.setLanguage(this.getContext().getUserContext().getLanguage());
        editProfileDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
        editProfileDto.setServType(UpdateProfileFeatures.ServTypeUpdateCategories);//UPDATE_USER_NAME or UPDATE_CATAGORIES or UPDATE_EMAIL or UPDATE_PROFILE_PIC
        editProfileDto.setUpdatableServiceValue(String(myAccountDto.getCategories())); // name or email or categoryId

        this.myAccountProcessor.getEditProfileAPIProcessor()
        .success((editProfileResponse: EditProfileResponse)=>
        {
            console.log("edit profile details success ################55555555555################");
            this.getAPIModelHandler().onSuccess(editProfileResponse.getAPIFeature(), 
            editProfileResponse.getDescription(), myAccountDto);
           
         })
        .failure((editProfileResponse: EditProfileResponse)=>
         {
           this.getAPIModelHandler().onFailure(editProfileResponse.getAPIFeature(), 
           editProfileResponse.getDescription(), undefined);
         })
        .execute(new EditProfileRequestImpl(editProfileDto));
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/myaccount/myaccountapimodel.tsx